module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_footer_marriage-2c109c539a9db606c072b7e19c15caac.svg";